import {
  defFetchList
} from '@/api/default'

const BASE_PATH = '/partner'

export function fetchList (query) {
  return defFetchList(BASE_PATH, query)
}
